import { defineComponent as d, openBlock as t, createElementBlock as e, mergeProps as i, unref as o, renderSlot as V, createElementVNode as l, createCommentVNode as p } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const u = { key: 0 }, g = { key: 1 }, v = { key: 2 }, Z = { key: 3 }, f = { key: 4 }, A = { key: 5 }, k = {
  name: "ScalarIconAlignCenterVerticalSimple"
}, M = /* @__PURE__ */ d({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const H = r, { bind: s, weight: n } = m(H);
    return (h, a) => (t(), e("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(s)), [
      V(h.$slots, "default"),
      o(n) === "bold" ? (t(), e("g", u, a[0] || (a[0] = [
        l("path", { d: "M208,116H180V48a20,20,0,0,0-20-20H96A20,20,0,0,0,76,48v68H48a12,12,0,0,0,0,24H76v68a20,20,0,0,0,20,20h64a20,20,0,0,0,20-20V140h28a12,12,0,0,0,0-24Zm-52,88H100V52h56Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), e("g", g, a[1] || (a[1] = [
        l("path", {
          d: "M168,48V208a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h64A8,8,0,0,1,168,48Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M208,120H176V48a16,16,0,0,0-16-16H96A16,16,0,0,0,80,48v72H48a8,8,0,0,0,0,16H80v72a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V136h32a8,8,0,0,0,0-16Zm-48,88H96V48h64Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), e("g", v, a[2] || (a[2] = [
        l("path", { d: "M216,128a8,8,0,0,1-8,8H176v72a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16V136H48a8,8,0,0,1,0-16H80V48A16,16,0,0,1,96,32h64a16,16,0,0,1,16,16v72h32A8,8,0,0,1,216,128Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), e("g", Z, a[3] || (a[3] = [
        l("path", { d: "M208,122H174V48a14,14,0,0,0-14-14H96A14,14,0,0,0,82,48v74H48a6,6,0,0,0,0,12H82v74a14,14,0,0,0,14,14h64a14,14,0,0,0,14-14V134h34a6,6,0,0,0,0-12Zm-46,86a2,2,0,0,1-2,2H96a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2h64a2,2,0,0,1,2,2Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), e("g", f, a[4] || (a[4] = [
        l("path", { d: "M208,120H176V48a16,16,0,0,0-16-16H96A16,16,0,0,0,80,48v72H48a8,8,0,0,0,0,16H80v72a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V136h32a8,8,0,0,0,0-16Zm-48,88H96V48h64Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), e("g", A, a[5] || (a[5] = [
        l("path", { d: "M208,124H172V48a12,12,0,0,0-12-12H96A12,12,0,0,0,84,48v76H48a4,4,0,0,0,0,8H84v76a12,12,0,0,0,12,12h64a12,12,0,0,0,12-12V132h36a4,4,0,0,0,0-8Zm-44,84a4,4,0,0,1-4,4H96a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4h64a4,4,0,0,1,4,4Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  M as default
};
